import { render } from "./Decks.vue?vue&type=template&id=4596c7c2&scoped=true"
import script from "./Decks.vue?vue&type=script&lang=js"
export * from "./Decks.vue?vue&type=script&lang=js"

import "./Decks.vue?vue&type=style&index=0&id=4596c7c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4596c7c2"]])

export default __exports__